import { createContext, useContext, useState } from "react";

const translations = {
  en: {
    "nav.home": "Home",
    "nav.inventory": "Inventory",
    "nav.loans": "Loans",
    "nav.about": "About",
    "nav.whatsapp": "WhatsApp",
    "hero.badge": "Yelahanka · Bengaluru · Since 2020",
    "hero.title1": "Buy Used Cars With",
    "hero.title2": "Total Transparency",
    "hero.desc": "Quality pre-owned vehicles with honest, upfront dealing and easy car loans for customers all across Karnataka. No hidden surprises — just trusted service.",
    "hero.browse": "Browse Inventory",
    "hero.chat": "Chat With Us",
    "trust.transparency": "Full Transparency",
    "trust.transparencyDesc": "Honest condition reports & fair pricing on every car.",
    "trust.loans": "Easy Car Loans",
    "trust.loansDesc": "Financing assistance for customers across Karnataka.",
    "trust.trusted": "Trusted Since 2020",
    "trust.trustedDesc": "Years of satisfied buyers in Bengaluru & beyond.",
    "featured.label": "Latest Stock",
    "featured.title": "Featured Cars",
    "featured.viewAll": "View All",
    "featured.empty": "No cars in stock right now. Check our WhatsApp catalogue.",
    "featured.catalogue": "→ Open WhatsApp Catalogue",
    "about.label": "Why Choose Us",
    "about.title": "Dealing You Can Actually Trust",
    "about.desc": "Shree Peteanjaneya Swamy Enterprises has been serving Bengaluru since 2020 from Yelahanka, Kogilu Circle. We believe buying a used car should be simple and honest — that's why we share every detail upfront: brand, year, ownership, model, transmission, fuel type, kilometres driven and price.",
    "about.fair": "Fair Pricing",
    "about.quick": "Quick Process",
    "about.karnataka": "All Karnataka",
    "loan.label": "Financing",
    "loan.title": "Apply For A Car Loan",
    "loan.desc": "Get easy financing to drive home your dream car. Fill the form and we'll reach out, or call us directly.",
    "loan.call": "Call",
    "loan.formTitle": "Loan Enquiry",
    "loan.name": "Full Name",
    "loan.phone": "Phone Number",
    "loan.car": "Car Interested In",
    "loan.message": "Message",
    "loan.submit": "Submit Enquiry",
    "loan.sending": "Sending...",
    "loan.namePh": "Your name",
    "loan.phonePh": "10-digit mobile",
    "loan.carPh": "e.g. Maruti Swift 2019",
    "loan.messagePh": "Tell us your requirement",
    "loan.success": "Enquiry sent! Opening WhatsApp to confirm.",
    "loan.required": "Please enter your name and phone number.",
    "inv.label": "Our Stock",
    "inv.title": "Car Inventory",
    "inv.available": "available",
    "inv.filters": "Filters",
    "inv.allBrands": "All Brands",
    "inv.allTrans": "All Transmissions",
    "inv.allFuel": "All Fuel Types",
    "inv.newest": "Newest First",
    "inv.priceLow": "Price: Low to High",
    "inv.priceHigh": "Price: High to Low",
    "inv.noMatch": "No cars match your filters.",
    "car.back": "Back",
    "car.year": "Year",
    "car.ownership": "Ownership",
    "car.transmission": "Transmission",
    "car.fuel": "Fuel Type",
    "car.kms": "Kilometers",
    "car.brand": "Brand",
    "car.description": "Description",
    "car.enquire": "Enquire on WhatsApp",
    "car.call": "Call",
    "car.share": "Share This Car",
    "car.sold": "SOLD",
    "car.unavailable": "This car is no longer available.",
    "car.backToInv": "Back to Inventory",
    "car.noImage": "No image",
    "footer.tagline": "Transparent used car buying & selling with easy loans across Karnataka. Trusted since 2020.",
    "footer.visit": "Visit Us",
    "footer.contact": "Get In Touch",
    "footer.chat": "Chat on WhatsApp",
    "footer.catalogue": "→ View WhatsApp Catalogue",
    "footer.rights": "All rights reserved.",
    "footer.admin": "Admin",
  },
  kn: {
    "nav.home": "ಮುಖಪುಟ",
    "nav.inventory": "ದಾಸ್ತಾನು",
    "nav.loans": "ಸಾಲಗಳು",
    "nav.about": "ನಮ್ಮ ಬಗ್ಗೆ",
    "nav.whatsapp": "ವಾಟ್ಸಾಪ್",
    "hero.badge": "ಯಲಹಂಕ · ಬೆಂಗಳೂರು · 2020 ರಿಂದ",
    "hero.title1": "ಸಂಪೂರ್ಣ ಪಾರದರ್ಶಕತೆಯಿಂದ",
    "hero.title2": "ಹಳೆಯ ಕಾರುಗಳನ್ನು ಖರೀದಿಸಿ",
    "hero.desc": "ಪ್ರಾಮಾಣಿಕ ಮತ್ತು ಸ್ಪಷ್ಟ ವ್ಯವಹಾರದೊಂದಿಗೆ ಗುಣಮಟ್ಟದ ಬಳಸಿದ ವಾಹನಗಳು ಮತ್ತು ಕರ್ನಾಟಕದಾದ್ಯಂತ ಗ್ರಾಹಕರಿಗೆ ಸುಲಭ ಕಾರು ಸಾಲಗಳು. ಯಾವುದೇ ಗುಪ್ತ ಆಶ್ಚರ್ಯಗಳಿಲ್ಲ — ಕೇವಲ ವಿಶ್ವಾಸಾರ್ಹ ಸೇವೆ.",
    "hero.browse": "ದಾಸ್ತಾನು ನೋಡಿ",
    "hero.chat": "ನಮ್ಮೊಂದಿಗೆ ಚಾಟ್ ಮಾಡಿ",
    "trust.transparency": "ಸಂಪೂರ್ಣ ಪಾರದರ್ಶಕತೆ",
    "trust.transparencyDesc": "ಪ್ರತಿ ಕಾರಿನ ಪ್ರಾಮಾಣಿಕ ಸ್ಥಿತಿ ವರದಿ ಮತ್ತು ನ್ಯಾಯಯುತ ಬೆಲೆ.",
    "trust.loans": "ಸುಲಭ ಕಾರು ಸಾಲಗಳು",
    "trust.loansDesc": "ಕರ್ನಾಟಕದಾದ್ಯಂತ ಗ್ರಾಹಕರಿಗೆ ಹಣಕಾಸು ನೆರವು.",
    "trust.trusted": "2020 ರಿಂದ ವಿಶ್ವಾಸಾರ್ಹ",
    "trust.trustedDesc": "ಬೆಂಗಳೂರು ಮತ್ತು ಸುತ್ತಮುತ್ತ ಹಲವು ವರ್ಷಗಳ ತೃಪ್ತ ಗ್ರಾಹಕರು.",
    "featured.label": "ಇತ್ತೀಚಿನ ದಾಸ್ತಾನು",
    "featured.title": "ವಿಶೇಷ ಕಾರುಗಳು",
    "featured.viewAll": "ಎಲ್ಲಾ ನೋಡಿ",
    "featured.empty": "ಸದ್ಯಕ್ಕೆ ದಾಸ್ತಾನಿನಲ್ಲಿ ಕಾರುಗಳಿಲ್ಲ. ನಮ್ಮ ವಾಟ್ಸಾಪ್ ಕ್ಯಾಟಲಾಗ್ ನೋಡಿ.",
    "featured.catalogue": "→ ವಾಟ್ಸಾಪ್ ಕ್ಯಾಟಲಾಗ್ ತೆರೆಯಿರಿ",
    "about.label": "ನಮ್ಮನ್ನೇ ಏಕೆ ಆಯ್ಕೆ ಮಾಡಬೇಕು",
    "about.title": "ನೀವು ನಿಜವಾಗಿಯೂ ನಂಬಬಹುದಾದ ವ್ಯವಹಾರ",
    "about.desc": "ಶ್ರೀ ಪೇಟೆಆಂಜನೇಯ ಸ್ವಾಮಿ ಎಂಟರ್‌ಪ್ರೈಸಸ್ 2020 ರಿಂದ ಯಲಹಂಕ, ಕೊಗಿಲು ಸರ್ಕಲ್‌ನಿಂದ ಬೆಂಗಳೂರಿಗೆ ಸೇವೆ ಸಲ್ಲಿಸುತ್ತಿದೆ. ಹಳೆಯ ಕಾರು ಖರೀದಿ ಸರಳ ಮತ್ತು ಪ್ರಾಮಾಣಿಕವಾಗಿರಬೇಕು ಎಂದು ನಾವು ನಂಬುತ್ತೇವೆ — ಆದ್ದರಿಂದ ನಾವು ಎಲ್ಲಾ ವಿವರಗಳನ್ನು ಮುಂಚಿತವಾಗಿ ಹಂಚಿಕೊಳ್ಳುತ್ತೇವೆ.",
    "about.fair": "ನ್ಯಾಯಯುತ ಬೆಲೆ",
    "about.quick": "ತ್ವರಿತ ಪ್ರಕ್ರಿಯೆ",
    "about.karnataka": "ಇಡೀ ಕರ್ನಾಟಕ",
    "loan.label": "ಹಣಕಾಸು",
    "loan.title": "ಕಾರು ಸಾಲಕ್ಕೆ ಅರ್ಜಿ ಸಲ್ಲಿಸಿ",
    "loan.desc": "ನಿಮ್ಮ ಕನಸಿನ ಕಾರನ್ನು ಮನೆಗೆ ತರಲು ಸುಲಭ ಹಣಕಾಸು ಪಡೆಯಿರಿ. ಫಾರ್ಮ್ ಭರ್ತಿ ಮಾಡಿ, ನಾವು ಸಂಪರ್ಕಿಸುತ್ತೇವೆ, ಅಥವಾ ನೇರವಾಗಿ ಕರೆ ಮಾಡಿ.",
    "loan.call": "ಕರೆ ಮಾಡಿ",
    "loan.formTitle": "ಸಾಲ ವಿಚಾರಣೆ",
    "loan.name": "ಪೂರ್ಣ ಹೆಸರು",
    "loan.phone": "ಫೋನ್ ಸಂಖ್ಯೆ",
    "loan.car": "ಆಸಕ್ತಿಯ ಕಾರು",
    "loan.message": "ಸಂದೇಶ",
    "loan.submit": "ವಿಚಾರಣೆ ಸಲ್ಲಿಸಿ",
    "loan.sending": "ಕಳುಹಿಸಲಾಗುತ್ತಿದೆ...",
    "loan.namePh": "ನಿಮ್ಮ ಹೆಸರು",
    "loan.phonePh": "10-ಅಂಕಿಯ ಮೊಬೈಲ್",
    "loan.carPh": "ಉದಾ. ಮಾರುತಿ ಸ್ವಿಫ್ಟ್ 2019",
    "loan.messagePh": "ನಿಮ್ಮ ಅಗತ್ಯವನ್ನು ತಿಳಿಸಿ",
    "loan.success": "ವಿಚಾರಣೆ ಕಳುಹಿಸಲಾಗಿದೆ! ದೃಢೀಕರಿಸಲು ವಾಟ್ಸಾಪ್ ತೆರೆಯಲಾಗುತ್ತಿದೆ.",
    "loan.required": "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಹೆಸರು ಮತ್ತು ಫೋನ್ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ.",
    "inv.label": "ನಮ್ಮ ದಾಸ್ತಾನು",
    "inv.title": "ಕಾರು ದಾಸ್ತಾನು",
    "inv.available": "ಲಭ್ಯವಿದೆ",
    "inv.filters": "ಫಿಲ್ಟರ್‌ಗಳು",
    "inv.allBrands": "ಎಲ್ಲಾ ಬ್ರ್ಯಾಂಡ್‌ಗಳು",
    "inv.allTrans": "ಎಲ್ಲಾ ಟ್ರಾನ್ಸ್‌ಮಿಷನ್",
    "inv.allFuel": "ಎಲ್ಲಾ ಇಂಧನ ವಿಧಗಳು",
    "inv.newest": "ಹೊಸದು ಮೊದಲು",
    "inv.priceLow": "ಬೆಲೆ: ಕಡಿಮೆಯಿಂದ ಹೆಚ್ಚು",
    "inv.priceHigh": "ಬೆಲೆ: ಹೆಚ್ಚಿನಿಂದ ಕಡಿಮೆ",
    "inv.noMatch": "ನಿಮ್ಮ ಫಿಲ್ಟರ್‌ಗಳಿಗೆ ಯಾವುದೇ ಕಾರುಗಳು ಹೊಂದಿಕೆಯಾಗುತ್ತಿಲ್ಲ.",
    "car.back": "ಹಿಂದೆ",
    "car.year": "ವರ್ಷ",
    "car.ownership": "ಮಾಲೀಕತ್ವ",
    "car.transmission": "ಟ್ರಾನ್ಸ್‌ಮಿಷನ್",
    "car.fuel": "ಇಂಧನ ವಿಧ",
    "car.kms": "ಕಿಲೋಮೀಟರ್",
    "car.brand": "ಬ್ರ್ಯಾಂಡ್",
    "car.description": "ವಿವರಣೆ",
    "car.enquire": "ವಾಟ್ಸಾಪ್‌ನಲ್ಲಿ ವಿಚಾರಿಸಿ",
    "car.call": "ಕರೆ ಮಾಡಿ",
    "car.share": "ಈ ಕಾರನ್ನು ಹಂಚಿಕೊಳ್ಳಿ",
    "car.sold": "ಮಾರಾಟವಾಗಿದೆ",
    "car.unavailable": "ಈ ಕಾರು ಇನ್ನು ಲಭ್ಯವಿಲ್ಲ.",
    "car.backToInv": "ದಾಸ್ತಾನಿಗೆ ಹಿಂತಿರುಗಿ",
    "car.noImage": "ಚಿತ್ರವಿಲ್ಲ",
    "footer.tagline": "ಕರ್ನಾಟಕದಾದ್ಯಂತ ಸುಲಭ ಸಾಲಗಳೊಂದಿಗೆ ಪಾರದರ್ಶಕ ಹಳೆಯ ಕಾರು ಖರೀದಿ ಮತ್ತು ಮಾರಾಟ. 2020 ರಿಂದ ವಿಶ್ವಾಸಾರ್ಹ.",
    "footer.visit": "ನಮ್ಮನ್ನು ಭೇಟಿ ಮಾಡಿ",
    "footer.contact": "ಸಂಪರ್ಕಿಸಿ",
    "footer.chat": "ವಾಟ್ಸಾಪ್‌ನಲ್ಲಿ ಚಾಟ್ ಮಾಡಿ",
    "footer.catalogue": "→ ವಾಟ್ಸಾಪ್ ಕ್ಯಾಟಲಾಗ್ ನೋಡಿ",
    "footer.rights": "ಎಲ್ಲಾ ಹಕ್ಕುಗಳನ್ನು ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ.",
    "footer.admin": "ಅಡ್ಮಿನ್",
  },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("spse_lang") || "en");
  const toggle = () => {
    const next = lang === "en" ? "kn" : "en";
    setLang(next);
    localStorage.setItem("spse_lang", next);
  };
  const t = (key) => translations[lang][key] ?? translations.en[key] ?? key;
  return (
    <LanguageContext.Provider value={{ lang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
